export default "__VITE_ASSET__e9cc204b__"